module.exports = __webpack_public_path__ + "img/malun.eae60a9a.jpg";